import React from 'react';
import { AdapterProps } from '../types';
import Typography from '../../Typography/Typography';
import Fields from '../Fields';
import Spacer from '../../Spacer/Spacer';

export type GroupAdapterProps = AdapterProps['group'];

const TextAdapter = (props: GroupAdapterProps) => {
  const { label, items } = props;

  return (
    <>
      {label && (
        <>
          <Spacer size={6} />
          <Typography variant="h3">{label}</Typography>
        </>
      )}
      <Fields fields={items} />
    </>
  );
};

export default TextAdapter;
